import { LoaderFunction, redirectDocument } from "react-router-dom";
import { getReaderURL } from "routes/bookshelfLinks.ts";

export const booksRouteLoader: LoaderFunction = ({ params, request }) => {
  if (params.vbid) {
    const url = new URL(request.url);
    return redirectDocument(
      `${getReaderURL(params.vbid)}/${params["*"]}${url.search}`
    );
  } else {
    return redirectDocument("/");
  }
};
